import { render, staticRenderFns } from "./sessionManagementPage.html?vue&type=template&id=449c748b&"
import script from "./sessionManagementPage.vue?vue&type=script&lang=js&"
export * from "./sessionManagementPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports